import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "admin-dashboard" }
const _hoisted_2 = { class: "admin-header py-3 px-4 d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-flex align-items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  class: "user-badge"
}
const _hoisted_5 = { class: "container-fluid py-4" }
const _hoisted_6 = { class: "row mb-4" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "nav nav-pills gap-2 admin-tabs justify-content-center" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-5 text-white"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "row align-items-center mb-3" }
const _hoisted_14 = { class: "col-md-4 mb-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-md-4 mb-2" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-md-4 mb-2 text-md-end" }
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = { class: "admin-card" }
const _hoisted_21 = { class: "card-img-wrapper" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "card-info p-3" }
const _hoisted_24 = { class: "fw-bold mb-2" }
const _hoisted_25 = { class: "badge bg-secondary ms-2" }
const _hoisted_26 = { class: "small text-truncate-3 m-0" }
const _hoisted_27 = { class: "small text-truncate-3 m-0" }
const _hoisted_28 = { class: "small text-truncate-3 m-0" }
const _hoisted_29 = { class: "small text-truncate-3 m-0" }
const _hoisted_30 = { class: "card-actions p-3 d-flex justify-content-end gap-2 border-top border-secondary" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "text-center py-5 text-white"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "row justify-content-between align-items-center mb-3" }
const _hoisted_36 = { class: "col-12 col-md-4 text-md-end" }
const _hoisted_37 = { class: "row justify-content-center" }
const _hoisted_38 = { class: "col-lg-8 col-12" }
const _hoisted_39 = { class: "table-responsive admin-table-container" }
const _hoisted_40 = { class: "table table-dark table-hover m-0" }
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "custom-modal-content" }
const _hoisted_46 = { class: "custom-modal-header d-flex justify-content-between align-items-center" }
const _hoisted_47 = { class: "fw-bold m-0" }
const _hoisted_48 = { class: "nav nav-tabs mb-3 dark-tabs" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "mb-3" }
const _hoisted_51 = { class: "form-label" }
const _hoisted_52 = ["onUpdate:modelValue", "required"]
const _hoisted_53 = { class: "mb-3" }
const _hoisted_54 = { class: "form-label" }
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = { class: "mb-3" }
const _hoisted_57 = { class: "form-label" }
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = { class: "mb-3" }
const _hoisted_60 = { class: "form-label" }
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = { class: "mb-3" }
const _hoisted_63 = { class: "form-label" }
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = { class: "mb-3" }
const _hoisted_66 = { class: "mb-3" }
const _hoisted_67 = {
  type: "file",
  ref: "imagesFile",
  class: "form-control dark-input",
  accept: "image/*"
}
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-md-6 mb-3" }
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "col-md-6 mb-3" }
const _hoisted_72 = { class: "custom-modal-footer d-flex justify-content-end gap-2 pt-3 border-top border-secondary" }
const _hoisted_73 = { class: "custom-modal-content max-w-sm" }
const _hoisted_74 = { class: "custom-modal-header d-flex justify-content-between align-items-center" }
const _hoisted_75 = { class: "fw-bold m-0" }
const _hoisted_76 = { class: "mb-3" }
const _hoisted_77 = { class: "mb-3" }
const _hoisted_78 = { class: "custom-modal-footer d-flex justify-content-end gap-2 pt-3 border-top border-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "brand" }, [
        _createElementVNode("h2", { class: "admin-title m-0" }, "KP Portfolio Admin")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.user.name)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _cache[22] || (_cache[22] = _createTextVNode("Signed in as: ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
          class: "btn btn-outline-danger btn-sm"
        }, "Sign Out")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link tab-btn", { active: _ctx.currentTab === 'ports' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTab = 'ports'))
              }, " Portfolio Items ", 2)
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link tab-btn", { active: _ctx.currentTab === 'categories' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentTab = 'categories'))
              }, " Categories ", 2)
            ])
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[24] || (_cache[24] = [
            _createElementVNode("div", {
              class: "spinner-border text-info",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1),
            _createElementVNode("p", { class: "mt-2" }, "Fetching dashboard data...", -1)
          ])))
        : (_ctx.currentTab === 'ports')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select dark-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCategory) = $event)),
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fetchPorts && _ctx.fetchPorts(...args)))
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, "All Categories", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: cat._id,
                        value: cat._id
                      }, _toDisplayString(cat.name), 9, _hoisted_15))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.filterCategory]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select dark-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.displayLanguage) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: lang,
                        value: lang
                      }, " Display: " + _toDisplayString(lang.toUpperCase()), 9, _hoisted_17))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.displayLanguage]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "btn btn-primary px-4",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openPortModal(null)))
                  }, " Add Portfolio Item ")
                ])
              ]),
              (_ctx.ports.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ports, (port) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-xl-4 col-md-6 col-12 mb-4",
                        key: port._id
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("img", {
                              src: _ctx.getImage(port?.images),
                              onError: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleImgError && _ctx.handleImgError(...args))),
                              class: "card-img",
                              alt: "Portfolio Image"
                            }, null, 40, _hoisted_22)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("h5", _hoisted_24, [
                              _createTextVNode(_toDisplayString(port.name[_ctx.displayLanguage] || port.name[_ctx.languages[0]]) + " ", 1),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getCategoryName(port.category)) + " (" + _toDisplayString(port.order_show) + ")", 1)
                            ]),
                            _createElementVNode("p", _hoisted_26, [
                              _cache[26] || (_cache[26] = _createElementVNode("strong", null, "Link:", -1)),
                              _createTextVNode(" " + _toDisplayString(port.link[_ctx.displayLanguage]), 1)
                            ]),
                            _createElementVNode("p", _hoisted_27, [
                              _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Content:", -1)),
                              _createTextVNode(" " + _toDisplayString(port.content[_ctx.displayLanguage]), 1)
                            ]),
                            _createElementVNode("p", _hoisted_28, [
                              _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Tech:", -1)),
                              _createTextVNode(" " + _toDisplayString(port.technology[_ctx.displayLanguage]), 1)
                            ]),
                            _createElementVNode("p", _hoisted_29, [
                              _cache[29] || (_cache[29] = _createElementVNode("strong", null, "API:", -1)),
                              _createTextVNode(" " + _toDisplayString(port.api[_ctx.displayLanguage]), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("button", {
                              class: "btn btn-info btn-sm text-white",
                              onClick: ($event: any) => (_ctx.openPortModal(port))
                            }, "Edit", 8, _hoisted_31),
                            _createElementVNode("button", {
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (_ctx.deletePort(port._id))
                            }, "Delete", 8, _hoisted_32)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[30] || (_cache[30] = [
                    _createElementVNode("p", null, "No portfolio items found. Click \"Add Portfolio Item\" to create one.", -1)
                  ])))
            ]))
          : (_ctx.currentTab === 'categories')
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-12 col-md-6" }, [
                    _createElementVNode("h4", { class: "text-white" }, "Categories Management")
                  ], -1)),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openCategoryModal(null)))
                    }, " Add Category ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("table", _hoisted_40, [
                        _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Category Name"),
                            _createElementVNode("th", null, "Show Order"),
                            _createElementVNode("th", { class: "text-end" }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: cat._id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(cat.name), 1),
                              _createElementVNode("td", null, _toDisplayString(cat.order_show), 1),
                              _createElementVNode("td", _hoisted_41, [
                                _createElementVNode("button", {
                                  class: "btn btn-info btn-sm text-white me-2",
                                  onClick: ($event: any) => (_ctx.openCategoryModal(cat))
                                }, "Edit", 8, _hoisted_42),
                                _createElementVNode("button", {
                                  class: "btn btn-danger btn-sm",
                                  onClick: ($event: any) => (_ctx.deleteCategory(cat._id))
                                }, "Delete", 8, _hoisted_43)
                              ])
                            ]))
                          }), 128)),
                          (_ctx.categories.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_44, _cache[32] || (_cache[32] = [
                                _createElementVNode("td", {
                                  colspan: "3",
                                  class: "text-center"
                                }, "No categories found. Click \"Add Category\" to create one.", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
    ]),
    (_ctx.showPortModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "custom-modal-backdrop",
          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.showPortModal = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h5", _hoisted_47, _toDisplayString(_ctx.form.id ? 'Edit' : 'Add') + " Portfolio Item", 1),
              _createElementVNode("button", {
                class: "btn-close btn-close-white",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showPortModal = false))
              })
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.savePort && _ctx.savePort(...args)), ["prevent"])),
              class: "custom-modal-body"
            }, [
              _createElementVNode("ul", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item",
                    key: lang
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["nav-link", { active: _ctx.activeFormLang === lang }]),
                      onClick: ($event: any) => (_ctx.activeFormLang = lang)
                    }, _toDisplayString(lang.toUpperCase()), 11, _hoisted_49)
                  ]))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "tab-content border-0 mb-3",
                  key: lang
                }, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, "Name (" + _toDisplayString(lang.toUpperCase()) + ")", 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.name[lang]) = $event),
                      class: "form-control dark-input",
                      required: _ctx.activeFormLang === lang
                    }, null, 8, _hoisted_52), [
                      [_vModelText, _ctx.form.name[lang]]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, "Link Data (" + _toDisplayString(lang.toUpperCase()) + ")", 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.link[lang]) = $event),
                      class: "form-control dark-input",
                      rows: "2"
                    }, null, 8, _hoisted_55), [
                      [_vModelText, _ctx.form.link[lang]]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("label", _hoisted_57, "Content (" + _toDisplayString(lang.toUpperCase()) + ")", 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.content[lang]) = $event),
                      class: "form-control dark-input",
                      rows: "2"
                    }, null, 8, _hoisted_58), [
                      [_vModelText, _ctx.form.content[lang]]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("label", _hoisted_60, "Technology (" + _toDisplayString(lang.toUpperCase()) + ")", 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.technology[lang]) = $event),
                      class: "form-control dark-input",
                      rows: "2"
                    }, null, 8, _hoisted_61), [
                      [_vModelText, _ctx.form.technology[lang]]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, "API (" + _toDisplayString(lang.toUpperCase()) + ")", 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.api[lang]) = $event),
                      class: "form-control dark-input",
                      rows: "2"
                    }, null, 8, _hoisted_64), [
                      [_vModelText, _ctx.form.api[lang]]
                    ])
                  ])
                ])), [
                  [_vShow, _ctx.activeFormLang === lang]
                ])
              }), 128)),
              _createElementVNode("div", _hoisted_65, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-label" }, "Image URL / Link", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.images_link) = $event)),
                  class: "form-control dark-input"
                }, null, 512), [
                  [_vModelText, _ctx.form.images_link]
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label" }, "Image File Upload", -1)),
                _createElementVNode("input", _hoisted_67, null, 512)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label" }, "Category", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.category) = $event)),
                    class: "form-select dark-select",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: cat._id,
                        value: cat._id
                      }, _toDisplayString(cat.name), 9, _hoisted_70))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.category]
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label" }, "Order Show", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.order_show) = $event)),
                    class: "form-control dark-input"
                  }, null, 512), [
                    [_vModelText, _ctx.form.order_show]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showPortModal = false))
                }, "Cancel"),
                _cache[38] || (_cache[38] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary"
                }, "Save Changes", -1))
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCategoryModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "custom-modal-backdrop",
          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.showCategoryModal = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("h5", _hoisted_75, _toDisplayString(_ctx.catForm.id ? 'Edit' : 'Add') + " Category", 1),
              _createElementVNode("button", {
                class: "btn-close btn-close-white",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showCategoryModal = false))
              })
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveCategory && _ctx.saveCategory(...args)), ["prevent"])),
              class: "custom-modal-body"
            }, [
              _createElementVNode("div", _hoisted_76, [
                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label" }, "Category Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.catForm.name) = $event)),
                  class: "form-control dark-input",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.catForm.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label" }, "Order Show", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.catForm.order_show) = $event)),
                  class: "form-control dark-input"
                }, null, 512), [
                  [_vModelText, _ctx.catForm.order_show]
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showCategoryModal = false))
                }, "Cancel"),
                _cache[41] || (_cache[41] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary"
                }, "Save Changes", -1))
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}